import Component from '../shared/component'

export const Data = Component('v-data', {
  functional: true,
  model: {
    prop: 'value',
    event: 'load'
  },
  props: {
    value: {
      default: null
    },
    expression: {
      default: null,
      required: true
    }
  },
  render (createElement, context) {
    const {props, data, listeners} = context
    const {value, expression} = props

    if (value === null || value === undefined) {
      if (listeners && listeners.load) {
        setTimeout(() => {
          listeners.load(expression)
        })
      }
    }

    if (data && data.scopedSlots) {
      return data.scopedSlots.default(expression)
    }
  }
})
